import { render } from "./matching.vue?vue&type=template&id=43efcaf3&ts=true"
import script from "./matching.ts?vue&type=script&lang=ts&external"
export * from "./matching.ts?vue&type=script&lang=ts&external"

import "./matching.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__